import { Model } from '@vuex-orm/core';
import { EquipmentSource } from '@/utils/constants'

export default class Equipment extends Model {
    static entity = 'equipments';

    static fields() {
        return {
            id: this.increment(),
            sap_id: this.number().nullable(),
            quantity: this.number().nullable(),
            size: this.number().nullable(),
            equipmentSource: this.number(EquipmentSource.ManualEquipment)
        }
    }
}